import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Field, Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import CustomFile from "../../../components/common/CustomFile";
import CustomInput from "../../../components/common/CustomInput";
import CustomSelect from "../../../components/common/CustomSelect";
import axiosAuthInstance from "../../../utils/axios/axiosAuthInstance";


const validationSchema = Yup.object({
  company: Yup.string().required("Company Name is Required"),
  name: Yup.string().required("Name is Required"),
  file: Yup.mixed()
    .required("File is Required")
    .test("fileType", "Only ZIP files are allowed", (value) => {
      if (value) {
        return value && value.name.endsWith(".zip");
      }
      return false;
    }),
});

const Add = () => {
  const navigate = useNavigate();
  const [companyOptions, setCompanyOptions] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const fetchCompanyData = async () => {
    try {
      const response = await axiosAuthInstance.get("company/dropdown");
      if (response && response.status === 200) {
        const transformedData = response?.data?.result?.map((item) => ({
          value: item._id,
          label: item.name,
        }));
        setCompanyOptions(transformedData);
      }
    } catch (error) {
      console.error("Error fetching company data", error);
    }
  };

  useEffect(() => {
    fetchCompanyData();
  }, []);

  const handleSubmit = async (values, { resetForm }) => {
    setIsSubmitted(true);
 
    if (!values.file || !(values.file instanceof File)) {
      console.error("File is missing or not a File object:", values.file);
      setIsSubmitted(false);
      return;
    }

    try {
      const formData = new FormData();
      formData.append("company", values.company);
      formData.append("name", values.name);
      formData.append("file", values.file);

      const response = await axiosAuthInstance.post("metaverse/add", formData);

      if (response && response.status === 200) {
        resetForm();
        navigate("/metaverse");
      }
    } catch (error) {
      console.error("Error Adding Metaverse", error);
    } finally {
      setIsSubmitted(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      company: "",
      name: "",
      file: null,
    },
    validationSchema: validationSchema,
    onSubmit: async (values, formikHelpers) => {
      const error = await formik.validateForm()
      if (Object.keys(error).length === 0) {
        handleSubmit(values, formikHelpers)
      } else {
        formikHelpers.setTouched(error)
      }
    },
  });

  return (
    <FormikProvider value={formik}>
      <Form
        className="flex flex-col p-4 gap-4"
        onSubmit={
          formik.handleSubmit}>
        <Field
          name="company"
          label="Select Company"
          required
          options={companyOptions}
          component={CustomSelect}
        />

        <Field
          name="name"
          label="Name"
          placeholder="Enter Name"
          required
          component={CustomInput}
        />

        <Field
          name="file"
          label="File"
          required
          accept=".zip"
          component={CustomFile}
          onChange={(event) => {
            formik.setFieldValue("file", event.currentTarget.files[0]);
          }}
        />

        <button
          type="submit"
          disabled={isSubmitted}
          className="bg-primary text-xl font-medium text-white rounded-lg px-6 py-2"
        >
          {isSubmitted ? (
            <div className="w-5 h-5 mx-auto border-2 border-white border-solid rounded-full loader animate-spin border-t-transparent"></div>
          ) : (
            "Create Metaverse"
          )}
        </button>
      </Form>
    </FormikProvider>
  );
};

export default Add;
